import { initializeApollo } from '@gql/client'
import { PaginaDocument } from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import { NewsletterTemplate } from '@components/templates'

const NewsletterPage = ({ pagina }) => <NewsletterTemplate pagina={pagina} />

export const getServerSideProps = NextWrapper.getServerSideProps(
  async ({ query, locale, preview, previewData, req, res }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'newsletter', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate')
    return {
      props: { pagina },
    }
  }
)

export default NewsletterPage
